import { Button, ModalDialog } from '@ctek/design-system';
import { FormattedMessage, useIntl } from 'react-intl';

import { CustomDateRange } from './CustomDateRange';

import { DateRange } from 'century-core/core-apis/learn/aggregations/aggregations';

interface Props {
  earliestYear: number;
  apply: (dateRange: DateRange, text: string) => void;
  initialSelection?: { start: string; end: string };
  setCustomDate: () => void;
  showCustomDatePicker: boolean;
  setShowCustomDatePicker: (param: boolean) => void;
}

export const CustomDateRangeModal: React.SFC<Props> = props => {
  const { earliestYear, apply, initialSelection, showCustomDatePicker, setShowCustomDatePicker, setCustomDate } = props;

  const intl = useIntl();

  return (
    <ModalDialog
      modalActive={showCustomDatePicker}
      onExit={() => setShowCustomDatePicker(false)}
      dismissLabel={intl.formatMessage({ id: 'modal-dismiss-button', defaultMessage: 'Dismiss' })}
      size={'flexible'}
      qa="teacher-dash-custom-date-modal"
    >
      <ModalDialog.Header>
        <ModalDialog.Title>
          <FormattedMessage id="custom-range-modal-header" defaultMessage="Custom date range" />
        </ModalDialog.Title>
      </ModalDialog.Header>
      <ModalDialog.Body>
        <CustomDateRange fromYear={earliestYear} apply={apply} initialSelection={initialSelection} />
      </ModalDialog.Body>
      <ModalDialog.Controls>
        <Button type="button" variant="default" size="small" onClick={() => setShowCustomDatePicker(false)}>
          <FormattedMessage id="completion-table-strand-menu-cancel-btn" defaultMessage="Cancel" />
        </Button>
        <Button type="button" variant="primary" size="small" onClick={setCustomDate}>
          <FormattedMessage id="completion-table-strand-menu-apply-btn" defaultMessage="Apply" />
        </Button>
      </ModalDialog.Controls>
    </ModalDialog>
  );
};
